import React from 'react';
import { ArrowUp, Github, Linkedin, Mail } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="relative border-t border-white/5 bg-[#0a0a0f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <p className="text-gray-500 text-sm font-mono">
              Built with passion for AI, Automation and Scalable Systems.
            </p>
            <p className="text-gray-600 text-xs mt-2 font-mono">
              &copy; {new Date().getFullYear()} Ranjithkumar Sekar — Application Engineer
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <a href={portfolioData.personal.github} target="_blank" rel="noopener noreferrer" className="p-2 text-gray-500 hover:text-indigo-400 transition-all duration-300 hover:scale-110"><Github size={18} /></a>
            <a href={portfolioData.personal.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 text-gray-500 hover:text-indigo-400 transition-all duration-300 hover:scale-110"><Linkedin size={18} /></a>
            <a href={`mailto:${portfolioData.personal.email}`} className="p-2 text-gray-500 hover:text-indigo-400 transition-all duration-300 hover:scale-110"><Mail size={18} /></a>
            <div className="w-px h-6 bg-white/10 mx-2" />
            <button onClick={scrollToTop} className="p-2.5 bg-white/5 hover:bg-indigo-500/20 text-gray-400 hover:text-indigo-400 rounded-xl transition-all duration-300 hover:scale-110 border border-white/5 hover:border-indigo-500/30"><ArrowUp size={16} /></button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
